export const onClientUsageUpdated = /* GraphQL */ `
  subscription onClientUsageUpdated($clientId: ID) {
  onClientUsageUpdated(clientId: $clientId) {
      aiUsageCount
      clientId
      itemsCount
      quizzesCount
  }
}
`;

export const onCreateClientUser = /* GraphQL */ `
  subscription onCreateClientUser($filter: ModelSubscriptionClientUserFilterInput, $ownerId: String) {
  onCreateClientUser(filter: $filter, ownerId: $ownerId) {
      avatarPath
      closedAt
      createdAt
      deletedAt
      email
      id
      isAdmin
      isConfirmed
      isReadOnly
      lastActive
      name
      ownerId
      roleUpdatedBy
      roles
      sub
      surname
      updatedAt
      version
  }
}
`;

export const onCreateItem = /* GraphQL */ `
  subscription onCreateItem($filter: ModelSubscriptionItemFilterInput, $ownerId: String) {
  onCreateItem(filter: $filter, ownerId: $ownerId) {
      ackUpdatedBy
      acknowledgement
      acknowledgementRequired
      archived
      childIds
      createdAt
      creator
      deletedAt
      description
      id
      name
      ownerId
      parentIds
      pinned
      pinnedIds
      readRoles
      slug
      statusRestoreParentIds
      statusSourceLibraryId
      statusUpdatedBy
      trashed
      type
      updatedAt
      updatedBy
      version
      workspaceId
      writeRoles
  }
}
`;

export const onCreateNotification = /* GraphQL */ `
  subscription onCreateNotification($filter: ModelSubscriptionNotificationFilterInput, $ownerId: String) {
  onCreateNotification(filter: $filter, ownerId: $ownerId) {
      channelAttempts
      createdAt
      deletedAt
      eventId
      id
      initiatorId
      meta
      ownerId
      status
      type
      updatedAt
      userId
  }
}
`;

export const onCreateWorkspace = /* GraphQL */ `
  subscription onCreateWorkspace($filter: ModelSubscriptionWorkspaceFilterInput, $ownerId: String) {
  onCreateWorkspace(filter: $filter, ownerId: $ownerId) {
      archivedIds
      avatarPath
      childIds
      createdAt
      deletedAt
      id
      name
      ownerId
      pinnedIds
      slug
      trashedIds
      updatedAt
      version
  }
}
`;

export const onCreateWorkspaceUser = /* GraphQL */ `
  subscription onCreateWorkspaceUser($filter: ModelSubscriptionWorkspaceUserFilterInput, $ownerId: String) {
  onCreateWorkspaceUser(filter: $filter, ownerId: $ownerId) {
      createdAt
      createdBy
      deletedAt
      id
      ownerId
      role
      updatedAt
      updatedBy
      userId
      version
      workspaceId
  }
}
`;

export const onDeleteClientUser = /* GraphQL */ `
  subscription onDeleteClientUser($filter: ModelSubscriptionClientUserFilterInput, $ownerId: String) {
  onDeleteClientUser(filter: $filter, ownerId: $ownerId) {
      avatarPath
      closedAt
      createdAt
      deletedAt
      email
      id
      isAdmin
      isConfirmed
      isReadOnly
      lastActive
      name
      ownerId
      roleUpdatedBy
      roles
      sub
      surname
      updatedAt
      version
  }
}
`;

export const onDeleteItem = /* GraphQL */ `
  subscription onDeleteItem($filter: ModelSubscriptionItemFilterInput, $ownerId: String) {
  onDeleteItem(filter: $filter, ownerId: $ownerId) {
      ackUpdatedBy
      acknowledgement
      acknowledgementRequired
      archived
      childIds
      createdAt
      creator
      deletedAt
      description
      id
      name
      ownerId
      parentIds
      pinned
      pinnedIds
      readRoles
      slug
      statusRestoreParentIds
      statusSourceLibraryId
      statusUpdatedBy
      trashed
      type
      updatedAt
      updatedBy
      version
      workspaceId
      writeRoles
  }
}
`;

export const onDeleteNotification = /* GraphQL */ `
  subscription onDeleteNotification($filter: ModelSubscriptionNotificationFilterInput, $ownerId: String) {
  onDeleteNotification(filter: $filter, ownerId: $ownerId) {
      channelAttempts
      createdAt
      deletedAt
      eventId
      id
      initiatorId
      meta
      ownerId
      status
      type
      updatedAt
      userId
  }
}
`;

export const onDeleteWorkspace = /* GraphQL */ `
  subscription onDeleteWorkspace($filter: ModelSubscriptionWorkspaceFilterInput, $ownerId: String) {
  onDeleteWorkspace(filter: $filter, ownerId: $ownerId) {
      archivedIds
      avatarPath
      childIds
      createdAt
      deletedAt
      id
      name
      ownerId
      pinnedIds
      slug
      trashedIds
      updatedAt
      version
  }
}
`;

export const onDeleteWorkspaceUser = /* GraphQL */ `
  subscription onDeleteWorkspaceUser($filter: ModelSubscriptionWorkspaceUserFilterInput, $ownerId: String) {
  onDeleteWorkspaceUser(filter: $filter, ownerId: $ownerId) {
      createdAt
      createdBy
      deletedAt
      id
      ownerId
      role
      updatedAt
      updatedBy
      userId
      version
      workspaceId
  }
}
`;

export const onUpdateClient = /* GraphQL */ `
  subscription onUpdateClient($filter: ModelSubscriptionClientFilterInput, $id: String) {
  onUpdateClient(filter: $filter, id: $id) {
      createdAt
      created_at
      customer_id
      defaultWorkspaces
      deletedAt
      feature_flags
      id
      inviteLink
      meta
      name
      ownerUserId
      slug
      subscription_details
      subscription_endsAt
      subscription_plan
      subscription_status
      updatedAt
      userRole
      version
  }
}
`;

export const onUpdateClientUser = /* GraphQL */ `
  subscription onUpdateClientUser($filter: ModelSubscriptionClientUserFilterInput, $ownerId: String) {
  onUpdateClientUser(filter: $filter, ownerId: $ownerId) {
      avatarPath
      closedAt
      createdAt
      deletedAt
      email
      id
      isAdmin
      isConfirmed
      isReadOnly
      lastActive
      name
      ownerId
      roleUpdatedBy
      roles
      sub
      surname
      updatedAt
      version
  }
}
`;

export const onUpdateItem = /* GraphQL */ `
  subscription onUpdateItem($filter: ModelSubscriptionItemFilterInput, $ownerId: String) {
  onUpdateItem(filter: $filter, ownerId: $ownerId) {
      ackUpdatedBy
      acknowledgement
      acknowledgementRequired
      archived
      childIds
      createdAt
      creator
      deletedAt
      description
      id
      name
      ownerId
      parentIds
      pinned
      pinnedIds
      readRoles
      slug
      statusRestoreParentIds
      statusSourceLibraryId
      statusUpdatedBy
      trashed
      type
      updatedAt
      updatedBy
      version
      workspaceId
      writeRoles
  }
}
`;

export const onUpdateNotification = /* GraphQL */ `
  subscription onUpdateNotification($filter: ModelSubscriptionNotificationFilterInput, $ownerId: String) {
  onUpdateNotification(filter: $filter, ownerId: $ownerId) {
      channelAttempts
      createdAt
      deletedAt
      eventId
      id
      initiatorId
      meta
      ownerId
      status
      type
      updatedAt
      userId
  }
}
`;

export const onUpdateWorkspace = /* GraphQL */ `
  subscription onUpdateWorkspace($filter: ModelSubscriptionWorkspaceFilterInput, $ownerId: String) {
  onUpdateWorkspace(filter: $filter, ownerId: $ownerId) {
      archivedIds
      avatarPath
      childIds
      createdAt
      deletedAt
      id
      name
      ownerId
      pinnedIds
      slug
      trashedIds
      updatedAt
      version
  }
}
`;

export const onUpdateWorkspaceUser = /* GraphQL */ `
  subscription onUpdateWorkspaceUser($filter: ModelSubscriptionWorkspaceUserFilterInput, $ownerId: String) {
  onUpdateWorkspaceUser(filter: $filter, ownerId: $ownerId) {
      createdAt
      createdBy
      deletedAt
      id
      ownerId
      role
      updatedAt
      updatedBy
      userId
      version
      workspaceId
  }
}
`;
